// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-checkbox-control.is-checked .components-checkbox-control__label {
    font-weight: bold;
}

.queryBuilder-dragHandle {
    font-size: 18px;
    color: #9a9a9a;
}

.queryBuilder-dragHandle:hover {
    color: #000;
}
`, "",{"version":3,"sources":["webpack://./assets/jsx/workflow-editor/css/query-builder.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".components-checkbox-control.is-checked .components-checkbox-control__label {\n    font-weight: bold;\n}\n\n.queryBuilder-dragHandle {\n    font-size: 18px;\n    color: #9a9a9a;\n}\n\n.queryBuilder-dragHandle:hover {\n    color: #000;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
